import React, { useEffect } from "react";
import { Grid, Card } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { CONFIGURACION_CONTRATOS } from "../../../../utils/permisos";
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import { makeStyles } from "@material-ui/core/styles";
import { eliminarModulo, fetchModulos, guardarModulo } from "../../../../actions/contrataciones/configuraciones/abmModulos";
import FormModulos from "./FormModulos";
import moment from 'moment'
import EditButtonAbm from "../../../compartidos/abms/EditButtonAbm";
import AddButtonAbm from "../../../compartidos/abms/AddButtonAbm";
import { DeleteButtonAbm } from "./DeleteButtonAbm";

const useStyles = makeStyles({
  root: {
    marginTop: "1rem"
  }
});

export const HomeModulos = () => {
  const { items = [] } = useSelector((state) => state.modulosContratos);

  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    dispatch(fetchModulos());
  }, [dispatch]);

  const handleSearch = (textoBuscado) => {
    dispatch(fetchModulos(textoBuscado));
  }

  const handleSave = (item, handleClose) => {
    if (item.idModulo) {
      dispatch(guardarModulo(item.idModulo, item, handleClose));
    } else {
      dispatch(guardarModulo(null, item, handleClose));
    }
  };

  const handleDelete = (id) => {
    dispatch(eliminarModulo(id));
  }

  return (
    <div className={classes.root}>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12}>
          <AddButtonAbm
            title="+ Agregar módulo"
            handleSave={handleSave}
            permiso={CONFIGURACION_CONTRATOS.ALTA}
            form={FormModulos}
            style={{ float: "right" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <BuscadorAbm title="Buscar Modulo" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label: "",
                  customBody: (item) => (
                    <>
                      <EditButtonAbm
                        handleSave={handleSave}
                        permiso={CONFIGURACION_CONTRATOS.MODIFICACION}
                        item={item}
                        form={FormModulos}
                      />
                      <DeleteButtonAbm
                        handleDelete={() => handleDelete(item.idModulo)}
                        mensajeEliminacion={`¿Estás seguro que deseas eliminar el modulo "${item.descripcion}"?`}
                        permiso={CONFIGURACION_CONTRATOS.BAJA}
                      />
                    </>
                  )
                },
                {
                  label: "Descripcion",
                  id: "descripcion",
                  sort: true
                },
                {
                  label: "Codigo",
                  id: "codigo",
                  sort: true
                },
                {
                  label: "Fecha Baja",
                  id: "fechaBaja",
                  sort: true,
                  customBody: (item) => item.fechaBaja ? moment(item.fechaBaja).format('DD/MM/YYYY') : ""
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};

export default HomeModulos; 
